import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $convertFromMarkdownString, TRANSFORMERS } from "@lexical/markdown";
import { useEffect, useRef } from "react";

/**
 * Puts text into the editor once, when it mounts: the draft a host kept while the editor was not on
 * screen. The proposal pane keeps a half-written comment through a remount this way.
 */
export function InitialMarkdownPlugin(props: Readonly<{ markdown?: string }>) {
  const { markdown } = props;
  const [editor] = useLexicalComposerContext();
  const seeded = useRef(false);

  useEffect(() => {
    if (seeded.current) return;
    seeded.current = true;
    if (!markdown) return;
    editor.update(() => {
      $convertFromMarkdownString(markdown, TRANSFORMERS);
    });
  }, [editor, markdown]);

  return null;
}
